export default __webpack_public_path__ + "static/media/item_6_active.02ff2669.png";